module.exports = __webpack_public_path__ + "static/media/logo.0086ad01.png";